import { Schedule } from "../model/schedule/Schedule";

export class SchedulePostCommand{
    schedule:Schedule;

    constructor(schedule:Schedule){
        this.schedule = schedule;
    }
}